export const API_URL = 'https://dev.danid-pro.com/test_pompier/api';
export const ROOT_URL = 'https://dev.danid-pro.com/test_pompier';

// export const API_URL = 'https://objectifofficiersp.com/api';
// export const ROOT_URL = 'https://objectifofficiersp.com';
